import {
  Backdrop,
  Box,
  CircularProgress,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import { colors } from "../../theme/theme";
import { EmailOutlined, LoginRounded } from "@mui/icons-material";
import {
  CustomInput,
  CustomPasswordInput,
} from "../../Components/Common/CustomInput";
import { useNavigate } from "react-router-dom";
import { CustomBtn } from "../../Components/Common/CustomBtn";
import AuthLayout from "../../layouts/AuthLayout";
import { loginUser } from "../../redux/actions/user.dispatcher";
import { ErrorSnackbar } from "../../Components/Common/CustomSnackbar";
import { useDispatch } from "react-redux";
import { getUserById } from "../../redux/actions/user.dispatcher";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const smallScreen = useMediaQuery("(max-width:800px)");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const handleLogin = async () => {
    setErrorState({ error: false, message: "" });
    if (!email) {
      setErrorState({ error: true, message: "Email is required" });
      return;
    }
    if (!password) {
      setErrorState({ error: true, message: "Password is required" });
      return;
    }

    try {
      setLoading(true);

      const login = await loginUser({
        email,
        password,
      });

      if (login.user) {
        await dispatch(getUserById(login.user.id));

        if (login.user.role === "admin") {
          navigate("/admin/dashboard");
        } else {
          navigate("/dashboard");
        }
      } else {
        if (login.UserId) {
          navigate("/mfa-login", {
            state: {
              userId: login.UserId,
            },
          });
        } else {
          setErrorState({ error: true, message: login.response.data.message });
        }
      }
    } catch (error) {
      console.log("error", error);
      setErrorState({ error: true, message: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout type="login">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CustomInput
        placeholder="Email"
        Icon={EmailOutlined}
        value={email}
        setValue={setEmail}
      />
      <CustomPasswordInput
        placeholder="Password"
        value={password}
        setValue={setPassword}
      />
      {/* <CustomDropDown
        value={userType}
        setValue={setUserType}
        title="Choose e.g. Regular user, Creator"
        label="Choose e.g. Regular user, Creator"
        data={userTypes || []}
        Icon={PersonOutline}
      /> */}

      <Stack
        direction={smallScreen ? "column" : "row"}
        sx={{
          justifyContent: "space-between",
          alignItems: smallScreen ? "flex-start" : "center",
          my: smallScreen ? 2 : 0,
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            color: colors.primary,
            fontFamily: "Inter-Regular",
            cursor: "pointer",
            textDecorationLine: "underline",
          }}
          onClick={() => navigate("/forgot-password")}
        >
          Forgot Password?
        </Typography>
        <CustomBtn
          text="Login"
          Icon={LoginRounded}
          width={smallScreen ? "50%" : "25%"}
          onClick={handleLogin}
        />
      </Stack>
      {smallScreen && (
        <Box
          sx={{
            position: "absolute",
            bottom: 10,
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              color: "#000",
              fontFamily: "Inter-Regular",
              textAlign: "center",
            }}
          >
            New at OnlyHands ?{" "}
            <Typography
              component={"span"}
              sx={{
                fontSize: "14px",
                color: colors.primary,
                fontFamily: "Inter-Regular",
                cursor: "pointer",
                textDecorationLine: "underline",
              }}
              onClick={() => navigate("/register")}
            >
              Register
            </Typography>
          </Typography>
        </Box>
      )}

      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
    </AuthLayout>
  );
};

export default Login;
